import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { rgba } from 'polished';
import { TableCell, TableRow } from '@this/src/components/shared/ui/data_displays/table';
import type BizEkinetBookingInventoryItem from '@this/src/domain/arrangement/biz_ekinet_booking_inventory_item';
import { Link } from '@this/src/components/shared/ui/navigations/link';
import { Button } from '@this/components/shared/ui/inputs/button';
import { Checkbox } from '@this/src/components/shared/ui/inputs/checkbox';
import { Fetcher } from '@this/src/util';
import InventoryCommentModal from '@this/components/arrangement/todo_list/auto_reservation_inventory/biz_ekinet_booking/inventory_comment_modal';

interface Props {
  item: BizEkinetBookingInventoryItem;
  checked: boolean;
  onInventory: () => void;
  onToggle: (checked: boolean) => void;
}

const ItemsResultTableRow = observer(({ item, checked, onInventory, onToggle }: Props) => {
  const [showLogModal, setShowLogModal] = useState<boolean>(false);

  const handleInventory = async () => {
    const bizEkinetBookingInventoryPairId = item.bizEkinetBookingInventoryPairId;
    if (!bizEkinetBookingInventoryPairId) return;

    await Fetcher.put(
      `/arrangement/auto_reservation_inventory/biz_ekinet_booking/items/${bizEkinetBookingInventoryPairId}/inventory.json`,
      {}
    );
    onInventory();
  };

  const handleCancelInventory = async () => {
    const bizEkinetBookingInventoryPairId = item.bizEkinetBookingInventoryPairId;
    if (!bizEkinetBookingInventoryPairId) return;
    await Fetcher.put(
      `/arrangement/auto_reservation_inventory/biz_ekinet_booking/items/${bizEkinetBookingInventoryPairId}/cancel_inventory.json`,
      {}
    );
    onInventory();
  };

  return (
    <TableRow
      style={{
        background:
          !item.bizEkinetBookingInventoryPairBizEkinetReservationId ||
          !item.bizEkinetBookingInventoryPairAiOperatorReservationId
            ? rgba('red', 0.3)
            : 'auto'
      }}
    >
      <TableCell>
        <Checkbox
          checked={checked}
          disabled={!!item.bizEkinetBookingInventoryPairInventoriedAt}
          onChange={e => onToggle(e.target.checked)}
        />
      </TableCell>
      <TableCell>
        {item.aiOperatorReservationId || '　'}
        <br />
        {item.bizEkinetReservationId || '　'}
      </TableCell>
      <TableCell>
        {item.aiOperatorReservationCreatedAt?.format('YYYY-MM-DD HH:mm') || '　'}
        <br />
        {item.bizEkinetReservationCreatedAt?.format('YYYY-MM-DD HH:mm') || '　'}
      </TableCell>
      <TableCell>{item.aiOperatorReservationStatus}</TableCell>
      <TableCell>{item.reservationNumber}</TableCell>
      <TableCell>{item.targetDate?.format('YYYY-MM-DD')}</TableCell>
      <TableCell>{item.price?.toLocaleString()}</TableCell>
      <TableCell>{item.reservationDate?.format('YYYY-MM-DD')}</TableCell>
      <TableCell>{item.aiOperatorReservationIsAutoProcessed ? '○' : ''}</TableCell>
      <TableCell>
        {item.aiOperatorIsInventoried || '　'}
        <br />
        {item.bizEkinetIsInventoried || '　'}
      </TableCell>
      <TableCell>
        {item.aiOperatorInventoriedBy || '　'}
        <br />
        {item.bizEkinetInventoriedBy || '　'}
      </TableCell>
      <TableCell>
        {item.aiOperatorInventoriedAt?.format('YYYY-MM-DD HH:mm') || '　'}
        <br />
        {item.bizEkinetInventoriedAt?.format('YYYY-MM-DD HH:mm') || '　'}
      </TableCell>
      <TableCell>
        <Link
          href={`/arrangement/virtual_counter?trip_id=${item.aiOperatorTripId}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {item.aiOperatorTripId || '　'}
        </Link>
        <br />
        <Link
          href={`/arrangement/virtual_counter?trip_id=${item.bizEkinetTripId}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {item.bizEkinetTripId || '　'}
        </Link>
      </TableCell>
      <TableCell>
        {item.aiOperatorOrderItemId || '　'}
        <br />
        {item.bizEkinetOrderItemId || '　'}
      </TableCell>
      <TableCell>
        {item.aiOperatorTraceId || '　'}
        <br />
        {item.bizEkinetTraceId || '　'}
      </TableCell>
      <TableCell>
        {item.bizEkinetBookingInventoryPairId && (
          <p>
            (<Link onClick={() => setShowLogModal(true)}>コメント</Link>)
          </p>
        )}
      </TableCell>
      <TableCell>
        {item.bizEkinetBookingInventoryPairId && item.bizEkinetBookingInventoryPairInventoriedAt ? (
          <Button size="small" onClick={() => handleCancelInventory()}>
            取消
          </Button>
        ) : (
          <Button size="small" onClick={() => handleInventory()}>
            棚卸完了
          </Button>
        )}
      </TableCell>
      {showLogModal && (item.bizEkinetTraceId || item.aiOperatorTraceId) && (
        <InventoryCommentModal
          inventoryPairId={item.bizEkinetBookingInventoryPairId}
          onClose={() => setShowLogModal(false)}
        />
      )}
    </TableRow>
  );
});

export default ItemsResultTableRow;
